module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('AdminTools'), _vm._v(" "), _c('div', {
    staticClass: "flexContainer full what"
  }, [_c('section', {
    attrs: {
      "id": "sectionPrincipal"
    }
  }, [(_vm.profile) ? _c('section', {
    staticClass: "brand-list"
  }, [_c('h1', {
    staticClass: "center",
    staticStyle: {
      "font-size": "50px"
    }
  }, [_vm._v(_vm._s(_vm.profile.name))]), _vm._v(" "), _c('section', {
    staticClass: "searchResultsWrapper"
  }, _vm._l((_vm.getAllApplications), function(app) {
    return _c('AppSection', {
      key: 'function_' + app.id,
      attrs: {
        "app": app,
        "access": _vm.access
      },
      on: {
        "changeRole": _vm.changeAccess
      }
    })
  }))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "functionBtn"
  }, [_c('div', {
    staticClass: "functionBtn"
  }, [_c('b-button-toolbar', {
    staticClass: "btnActionUser"
  }, [_c('button', {
    staticClass: "btn btn-dark uppercase",
    on: {
      "click": function($event) {
        _vm.$router.push({
          path: "/admin/profiles"
        });
      }
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.$t("common.cancel")) + "\n                        ")]), _vm._v(" "), _c('button', {
    staticClass: "btn-dark btn uppercase",
    on: {
      "click": _vm.save
    }
  }, [_vm._v(_vm._s(_vm.$t("common.save")))])])], 1)])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-620619e4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/profiles/ProfileRole.vue
// module id = 3223
// module chunks = 0